import { Component } from "@angular/core";
import { Api } from "../../services/api";
import { NavController } from "ionic-angular";

const groupBuySuccessfulHintMute = "group_buy_successful_hint_mute";

/**
 * Generated class for the MyCampaignsBtnComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "my-campaigns-btn",
  templateUrl: "my-campaigns-btn.html",
})
export class MyCampaignsBtnComponent {
  text: string;
  showRedeemHint: boolean;
  showGroupBuyPurchaseSuccessfulHint: boolean;
  muteCurrentHint: Function;

  constructor(private api: Api, private navCtrl: NavController) {
    this.tryToShowRedeemHint();
  }

  private tryToShowRedeemHint() {
    if (window.location.hash.indexOf("/order/") < 0) {
      let intervalId = setInterval(() => {
        if (window["UserService"] && window["UserService"].isLoggedIn()) {
          clearInterval(intervalId);
          this.api.getCampaignsList("mine", false).then((result) => {
            for (let i = 0; i < result.length; i++) {
              if (result[i].campaign_type != 1 || result[i].state != 1) {
                continue;
              }

              let purchaseDate = Date.parse(
                result[i].created_at.replace(/-/g, "/")
              );
              let dateDiff = Date.now() - purchaseDate;
              if (dateDiff > 10 * 86400 * 1000) {
                continue;
              }

              if (
                (localStorage[groupBuySuccessfulHintMute] || "").indexOf(
                  result[i].id + ","
                ) >= 0
              ) {
                continue;
              }

              this.showRedeemHint = true;

              this.muteCurrentHint = () => {
                localStorage[groupBuySuccessfulHintMute] =
                  (localStorage[groupBuySuccessfulHintMute] || "") +
                  result[i].id +
                  ",";
              };
              break;
            }
          });
        }
      }, 500);
    }
  }

  hasBottomButton() {
    let btn = document.getElementsByClassName("my-campaigns-button")[0];
    if (btn) {
      return btn.parentElement.className.indexOf("with-button-at-bottom") >= 0;
    }
    return false;
  }

  hideBackDrop() {
    console.log("hide back drop");
    this.showRedeemHint = false;
    this.showGroupBuyPurchaseSuccessfulHint = false;

    if (this.backdropHideResolve) {
      this.backdropHideResolve();
      this.backdropHideResolve = null;
    }
  }

  navigateToMyCampaigns() {
    if (!window["UserService"].isLoggedIn()) {
      window["UserService"].showLogin();
      return;
    }
    window.location.hash = "/my-campaigns";
  }

  backdropHideResolve = null;

  ngOnInit() {
    window["showGroupBuyPurchaseSuccessfulHint"] = () => {
      return new Promise((resolve) => {
        this.showGroupBuyPurchaseSuccessfulHint = true;
        this.backdropHideResolve = resolve;
      });
    };
  }
}



// WEBPACK FOOTER //
// ./src/components/my-campaigns-btn/my-campaigns-btn.ts